import { Delete } from '@mui/icons-material';
import { Alert, Box, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MultiSelect from 'react-multiselect-checkboxes';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import SubjectTopicWeightage from './SubjectTopicWeightage';
import './AddQuizModel.css';
import firebase from 'firebase';
const AddQuizModal = ({
  isTeacher,
  fetchSubject,
  isOpen,
  toggleModal,
  saveQuiz,
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const [error, setError] = useState('');

  const [quizData, setQuizData] = useState({
    id: Date.now().toString(36) + Math.random().toString(36).substring(2, 15),
    name: '',
    numberOfQuation: '',
    price: 0,
    status: 0,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(), // Local timestamp
    subject: [],
    rule: 0,
    subjectWeitage: [],
    time: '',
  });

  console.log(quizData, 'quizData1212');

  // Handle input change for main fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuizData({
      ...quizData,
      [name]:
        name === 'numberOfQuation' || name === 'price'
          ? Number(value) || ''
          : value, // Handle price as a number
    });
  };

  // Handle input change for subjectWeightage
  const handleSubjectChange = (selectedOptions) => {
    const updatedSubjects = selectedOptions.map((option) => ({
      name: option.label,
      value: option.value,
    }));

    setQuizData((prev) => ({
      ...prev,
      subject: updatedSubjects,
    }));
  };

  const handleCheckFirstStep = () => {
    if (!quizData?.name) {
      setError('Mock Name is Required');
    } else if (quizData?.subject?.length == 0) {
      setError('Mock Subject is Required');
    } else if (!quizData?.time) {
      setError('Mock Time is Required');
    } else if (quizData?.time <= 0) {
      setError('Mock Time Must be a positive number');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      name,
      price,
      subjectWeitage,
      rule,
      time,
      positiveMarks,
      negativeMarks,
    } = quizData;

    let numberOfQuestions = 0;
    let hasError = false;

    const getData = subjectWeitage.map((weitage) => {
      let parseSubjectQuestion = parseInt(weitage?.questionPerSub);
      numberOfQuestions += parseSubjectQuestion;

      return {
        subjectId: weitage?.subjectId,
        subjectName: weitage?.subjectName,
        subjectQuestion: parseSubjectQuestion,
        TopicWeightage: weitage?.selectedTopics,
      };
    });

    // Stop execution if there's an error
    if (hasError) return;

    const finalData = {
      name,
      rule: rule || 0,
      numberOfQuation: numberOfQuestions,
      price: price || 0,
      status: 0,
      quizTime: parseInt(time),
      positiveMarks: parseFloat(positiveMarks) || 1,
      negativeMarks: parseFloat(negativeMarks) || 0,
      subjectWeightage: getData,
    };
    console.log(finalData, 'finalData');
    
    // Call saveQuiz and only close modal if successful
    try {
      await saveQuiz(finalData);
      // Only close modal if saveQuiz succeeds (doesn't throw error)
      toggleModal();
    } catch (error) {
      // Don't close modal if there's an error
      console.error('Error saving quiz:', error);
      // Error is already handled in handleSaveQuiz with notify
    }
  };

  const handleSubmitChecker = (e) => {
    e.preventDefault();
    let hasError = false;

    quizData?.subjectWeitage?.map((sw) => {
      if (sw?.totalWeitagePercentage != 100) {
        setError('Total Weightage Percentage For Each Subject Must be 100');
        hasError = true;
      }
    });

    if (!hasError) {
      handleSubmit(e);
    }
  };

  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
  };

  useEffect(() => {
    if (quizData?.subject?.length > 0) {
      setQuizData({
        ...JSON?.parse(JSON?.stringify(quizData)),
        subjectWeitage: fetchSubject
          .filter((subject) =>
            quizData?.subject?.some((subj) => subj.value === subject.id)
          )
          ?.map((item) => ({
            subjectName: item?.name,
            subjectId: item?.id,
            isEqual: false,
            questionPerSub: '',
            selectedTopics: [],
            totalWeitagePercentage: 0,
            topics: item?.topics?.map((topic) => ({
              name: topic,
              noOfQuestion: 0,
            })),
          })),
      });
    }
  }, [quizData?.subject?.length]);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('');
      }, 5000);
    }
  }, [error]);

  useEffect(() => {
    if (!isOpen) {
      setQuizData({
        id:
          Date.now().toString(36) + Math.random().toString(36).substring(2, 15),
        name: '',
        numberOfQuation: '',
        price: 0,
        status: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(), // Local timestamp
        subject: [],
        rule: 0,
        subjectWeitage: [],
        time: '',
      });
      setCurrentStep(1);
    }
    return () => {
      setQuizData({
        id:
          Date.now().toString(36) + Math.random().toString(36).substring(2, 15),
        name: '',
        numberOfQuation: '',
        price: 0,
        status: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(), // Local timestamp
        subject: [],
        rule: 0,
        subjectWeitage: [],
        time: '',
      });
      setCurrentStep(1);
    };
  }, [isOpen]);

  console.log('quizData355', quizData);

  return (
    <>
      {error && (
        <Box
          sx={{
            position: 'fixed',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            minWidth: '300px',
          }}
        >
          <Alert severity='error'>{error}!</Alert>
        </Box>
      )}
      <Modal
        isOpen={isOpen}
        style={{
          borderRadius: '8px',
          padding: '8px',
          margin: '0 auto',
          height: '71.5vh',

          transform: 'translateY(0)',
        }}
        toggle={toggleModal}
        size='lg'
      >
        <div
          style={{
            backgroundColor: 'rgb(39, 41, 61)',
            padding: '10px 15px',
            color: '#fff',
            fontSize: '18px',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Add Mock Exam
          <button
            type='button'
            className='close'
            onClick={() => {
              setQuizData({
                id:
                  Date.now().toString(36) +
                  Math.random().toString(36).substring(2, 15),
                name: '',
                numberOfQuation: '',
                price: 0, // New price field
                status: 0, // Default value, not editable by the user
                createdAt: firebase.firestore.FieldValue.serverTimestamp(), // Local timestamp
                subject: [],
                rule: '',
              });
              setCurrentStep(1);

              setTimeout(() => {
                toggleModal();
              }, 500);
            }}
            style={{
              color: '#fff',
              fontSize: '24px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
            }}
          >
            &times;
          </button>
        </div>

        <ModalBody
          style={{
            backgroundColor: 'rgb(39, 41, 61)',
            paddingTop: '20px',
            overflowY: 'auto',
            height: '71.5vh',
          }}
        >
          <form onSubmit={handleSubmit}>
            {currentStep === 1 ? (
              <div>
                {/* Mock Name */}
                <Row>
                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>Mock Name*</Label>
                      <Input
                        type='text'
                        name='name'
                        value={quizData.name}
                        onChange={handleInputChange}
                        placeholder='Enter quiz name'
                        style={inputStyle}
                        required
                      />
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>Price(Optional)</Label>
                      <Input
                        disabled={isTeacher ? true : false}
                        type='number'
                        name='price'
                        value={quizData.price}
                        onChange={handleInputChange}
                        placeholder='Enter quiz price'
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Subject Weightage */}
                <Row>
                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>Rule*</Label>
                      <Input
                        className='form-control'
                        style={{
                          display: 'block',
                          width: '100%',
                          height: '35px',
                          outline: 'none',
                          background: 'transparent',
                          color: 'white',
                          borderRadius: '4px',
                          padding: '2px',
                        }}
                        type='select'
                        name='option'
                        id='optionSelect'
                        value={quizData.option}
                        onChange={(e) =>
                          setQuizData({ ...quizData, rule: e?.target?.value })
                        }
                      >
                        <option value='' disabled>
                          Select an Option
                        </option>
                        <option value={0}>
                          Can Change Subject Without Submiting
                        </option>
                        <option value={1}>
                          Can't Change Subject Without Submit
                        </option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      {/* {quizData.subjectWeightage.map((item, index) => ( */}
                      <Label style={{ color: '#fff' }}>Select Subjects*</Label>

                      <MultiSelect
                        options={fetchSubject.map((subject) => ({
                          label: subject.name,
                          value: subject.id,
                        }))}
                        value={quizData.subject.map((subj) => ({
                          label: subj.name,
                          value: subj.value,
                        }))}
                        onChange={handleSubjectChange}
                        placeholder='Select Subjects'
                        isMulti
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: '7px',
                            minHeight: '40px',
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999, // Ensures dropdown is above other elements
                          }),
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>
                        Time* (in Minutes)
                      </Label>
                      <Input
                        type='number'
                        name='time'
                        value={quizData.time}
                        onChange={(e) => {
                          setQuizData({ ...quizData, time: e?.target?.value });
                        }}
                        placeholder='Enter quiz time'
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>
                        Positive Marking per Question
                      </Label>
                      <Input
                        type='number'
                        name='positiveMarks'
                        value={quizData.positiveMarks}
                        onChange={(e) => {
                          setQuizData({
                            ...quizData,
                            positiveMarks: e.target.value,
                          });
                        }}
                        placeholder='Enter positive marks per question'
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label style={{ color: '#fff' }}>
                        Negative Marking per Question
                      </Label>
                      <Input
                        type='number'
                        name='negativeMarks'
                        value={quizData.negativeMarks}
                        onChange={(e) => {
                          setQuizData({
                            ...quizData,
                            negativeMarks: e.target.value,
                          });
                        }}
                        placeholder='Enter negative marks per question'
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            ) : (
              <SubjectTopicWeightage
                loopData={quizData?.subjectWeitage}
                quizData={quizData}
                setQuizData={setQuizData}
                setError={setError}
              />
            )}
          </form>
        </ModalBody>

        <ModalFooter
          style={{
            backgroundColor: 'rgb(39, 41, 61)',
            display: 'flex',
            justifyContent: 'end',
            gap: '6px',
            padding: '12px',
          }}
        >
          <Button
            color='secondary'
            onClick={() => {
              setQuizData({
                id:
                  Date.now().toString(36) +
                  Math.random().toString(36).substring(2, 15),
                name: '',
                numberOfQuation: '',
                price: '', // New price field
                status: 0, // Default value, not editable by the user
                createdAt: firebase.firestore.FieldValue.serverTimestamp(), // Local timestamp
                subject: [],
                rule: '',
              });
              setCurrentStep(1);

              setTimeout(() => {
                toggleModal();
              }, 500);
            }}
          >
            Cancel
          </Button>
          {currentStep === 1 ? (
            <Button
              type='button'
              onClick={() => {
                if (
                  quizData?.name &&
                  quizData?.subject?.length > 0 &&
                  quizData?.time &&
                  +quizData?.time > 0
                ) {
                  setCurrentStep(2);
                } else {
                  handleCheckFirstStep();
                }
              }}
              color='info'
            >
              Next
            </Button>
          ) : (
            <Button type='button' color='info' onClick={handleSubmitChecker}>
              Submit
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddQuizModal;
